import React, { useEffect } from 'react';
import { LOGIN_TYPE } from '@whelk/services/src/user';
import PlainModal from '@whelk/components/src/Base/PlainModal';
import { ModalCloseIcon } from '@whelk/assets/src/web/common-icons';

import { QRCodeObj } from './constants';
import LoginFormComponent from './components/LoginFormFields';
import useLogin from './hooks/useLogin';
import ConfirmModal from './components/ConfirmModal';
import WXBindPhoneModal from './components/WXBindPhoneModal';

declare global {
  interface Window {
    WxLogin: any;
  }
}

const LoginModal: React.FC = () => {
  const { getVerifyCode, tip, showLoginModal, loginModalText, onClose } = useLogin();

  useEffect(() => {
    if (window.WxLogin && showLoginModal) {
      new window.WxLogin(QRCodeObj);
      window.addEventListener('message', getVerifyCode, false);
    }
    return () => {
      window.removeEventListener('message', getVerifyCode, false);
    };
  }, [showLoginModal]);

  return (
    <>
      <PlainModal
        open={showLoginModal}
        onClickMask={onClose}
        className='p-0 md:max-w-[678px]'
        size='lg'
      >
        <div className='login-modal-wrapper'>
          <div
            className='md:hover:bg-col_bg14 absolute  right-4 top-4 flex h-4 w-4 cursor-pointer items-center justify-center rounded-[8px] md:right-6 md:top-6 md:h-8 md:w-8'
            onClick={onClose}
          >
            <ModalCloseIcon />
          </div>

          <div className='flex h-full justify-center pb-5 pt-9 md:py-[61px]'>
            {/* 二维码登录 */}
            <div className='border-col_line00 hidden min-w-[278px] flex-row border-r-[1px]  border-solid  md:block'>
              <div className='login-title text-col_text00 mb-[27px] flex justify-center text-2xl font-[500]'>
                {loginModalText?.leftTitle}
              </div>
              <div
                id='wxcode'
                className='shadow-s2 mx-auto flex h-[180px] w-[180px] justify-center overflow-hidden rounded-[8px]'
              ></div>
              <div className='mt-[26px] flex items-center justify-center'>
                <img
                  src='./assets/img/share_wechat_friends.png'
                  className='mx-[2px] h-[20px] w-[20px]'
                ></img>
                <div className='text-col_text00 flex text-[16px]'>{tip}</div>
              </div>
            </div>
            {/* 分割线 */}
            {/* <div className='h-[420px]'></div> */}

            {/* 验证码登录 */}
            <div className='w-[400px] px-4 md:px-[35px] md:py-0'>
              <div className='mb-[26px] hidden md:block'>
                <div className='text-col_text00 flex justify-center text-2xl font-[500] md:flex'>
                  {loginModalText.rightTitle}
                </div>
                <div className='md:hidden'>
                  <div className='login-title text-col_text00 text-2xl font-semibold'>
                    {loginModalText.leftTitle}
                  </div>
                  <div className='ext-col_text00 mb-10 mt-[8px] text-base'>
                    {loginModalText.leftSubTitle}
                  </div>
                </div>
              </div>
              <div className='w-full '>
                <div className='text-col_text00  mb-[24px] text-center text-[16px] font-[500] md:hidden'>
                  登录后免费使用完整功能
                </div>
                <LoginFormComponent loginType={LOGIN_TYPE.LOGINTYPEPHONE} />
              </div>
            </div>
          </div>
        </div>
      </PlainModal>

      {/* 微信登录绑定手机号弹窗 */}
      <WXBindPhoneModal />
      <ConfirmModal
      // open={confirmModalOpen}
      // onConfirm={onSecondConfirm}
      // onCancel={onSecondCancel}
      />
    </>
  );
};

export default LoginModal;
